<!-- 论文题目设置 -->
<template>
    <div class="el-TopicSetting">
        <el-row class="page_content">
            <h1 class="head_title">论文题目设置</h1>
            <el-table
                :data="tableData"
                border
                style="width: 100%;">
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="论文题目">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="专业">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="导师姓名">
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
export default {
  name: "TopicSetting",
  data() {
    return {
        tableData: [],
    };
  },
  created() {
   
  },
  methods: {
    
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-TopicSetting{
    .wd{
        color: @red;
    }
    // .el-dialog__body{
    //     border-top:1px solid #ebeef5;
    // }
  }
</style>


// WEBPACK FOOTER //
// src/pages/dissertation/TopicSetting.vue